import React from 'react';
import { Dialog, DialogContent, Box } from '@mui/material';
import { RelatedEntityFilterBuilder } from './RelatedEntityFilterBuilder';
import { RelatedEntityConfigInput } from '../../../../types/generated-types';

export const RelatedEntityFilterDialog = ({
  relatedEntityFilter,
  onRelatedEntityFilterChange,
  targetModel,
  tiers,
  open,
  onClose,
}: {
  relatedEntityFilter: RelatedEntityConfigInput;
  targetModel: string;
  onRelatedEntityFilterChange: (
    relatedEntityFilter: RelatedEntityConfigInput,
  ) => void;
  tiers: number;
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <Box>
          <RelatedEntityFilterBuilder
            relatedEntityFilter={relatedEntityFilter}
            targetModel={targetModel}
            onSaveOrUpdateFilter={onRelatedEntityFilterChange}
            onClose={onClose}
            tiers={tiers}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};
